// extracted by mini-css-extract-plugin
export default {"card":"Card_card__63bmK","label":"Card_label__pnODh","value":"Card_value__M2mTZ"};